/* 🤖 this file was generated by script */
export const wiconUserCircle = {
  name: 'user_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.32 19.44A4 4 0 019 17h6a4 4 0 013.68 2.44M16 9.5a4 4 0 11-8 0 4 4 0 018 0zm6 2.5a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
